import styled from 'styled-components';
import DefaultTab from 'components/Tab';
import DefaultContentLoader from 'react-content-loader';
import { Body } from 'components/Typography';

export const Container = styled.div``;

export const ContentLoader = styled(DefaultContentLoader)<{ opacity: number }>`
  opacity: ${(props) => props.opacity};
`;

export const LoaderWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  margin-bottom: 1.5rem;
  padding: 2rem;
`;

export const Tabs = styled.nav`
  display: flex;
  margin-bottom: 1.5rem;
`;

export const Tab = styled(DefaultTab)`
  :not(:last-child) {
    margin-right: 1rem;
  }
`;

export const WarnCard = styled.div`
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.colors.redExtraLight};
  min-height: 4rem;
  padding: 1.375rem 2rem 1.125rem 2rem;
`;

export const WarnText = styled(Body)`
  font-size: 1.0625rem;
  color: ${({ theme }) => theme.colors.redMedium};
  span {
    font-weight: 600;
  }
`;
